import { Injectable } from '@angular/core';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { ItemModel } from './item.model';
import { ItemPivotModel } from './item-pivot.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../models/api-response.model';
import { FileModel } from '../shared/file.model';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {
  private readonly resourceUrl = 'items';

  constructor(private api: ApiRequestService) {}

  public findFilesForPivot(
    id: number
  ): Observable<ApiResponseModel<FileModel[]>> {
    return this.api.makeRequestObservable(
      'get',
      'v1/' + this.resourceUrl + `/pivot/${id}/files`
    );
  }

  public delete(id: number): Observable<{}> {
    return this.api.makeRequestObservable('delete', `v1/items/${id}`);
  }

  public find(
    id: number,
    pivotId?: number
  ): Observable<ItemModel> {
    if (pivotId) {
      return this.api.makeRequestObservable(
        'get',
        `v1/items/${id}?pivot_id=${pivotId}`
      );
    }
    return this.api.makeRequestObservable('get', `v1/items/${id}`);
  }

  public findPivot(id: number): Observable<ApiResponseModel<ItemPivotModel>> {
    return this.api.makeRequestObservable('get', `v1/items/pivot/${id}`);
  }

  public put(item: ItemModel): Observable<{}> {
    return this.api.makeRequestObservable('put', `v1/items/${item.id}`, item);
  }

  public updatePivot(
    id: number,
    pivot: ItemPivotModel
  ): Promise<ApiResponseModel<null>> {
    return this.api
      .makeRequestObservable('put', `v1/items/pivot/${id}`, pivot)
      .toPromise();
  }

  public post(item: ItemModel): Observable<ItemModel> {
    return this.api.makeRequestObservable('post', 'v1/items', item);
  }

  public get(): Observable<ItemModel[]> {
    return this.api.makeRequestObservable('get', 'v1/items');
  }

  public approve(pivotId: number): Observable<{}> {
    return this.api.makeRequestObservable('patch', `v1/items/approve/${pivotId}`);
  }

  public reject(pivotId: number, contractorId: number): Observable<{}> {
    return this.api.makeRequestObservable(
      'patch',
      'v1/' + this.resourceUrl + `/reject/${pivotId}`,
      { contractor_id: contractorId }
    );
  }
}
